/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { FormFieldText } from "../../../shared/FormModel/elements/FormFieldText";
import { FormFieldWrapperComponent } from "./FormFieldWrapperComponent";

/**
 * Component props
 */
export interface IFormFieldTextComponentProps {
	element: FormFieldText
}

/**
 * Form Field Text component
 *
 * @param props Component props
 */
export function FormFieldTextComponent(props: IFormFieldTextComponentProps) {

	const handleChange = (ev) => {
		props.element.set(ev.target.value);
	};

	return <FormFieldWrapperComponent {...props} render={(state, stl) => {

		const mods = [
			"align-" + (state.config.align || "left")
		];

		if (state.config.rows > 1) {
			mods.push("multiline");
		}

		const printValue = state.config.printFormatter ? state.config.printFormatter(state.value) : state.value;

		const inputEl = state.config.rows > 1 ? <textarea
			className={stl.el("input").mod(mods).str}
			name={state.valueId}
			placeholder={state.config.placeholder}
			value={state.value || ""}
			rows={state.config.rows}
			onChange={handleChange}
		/> : <input
			className={stl.el("input").mod(mods).str}
			type="text"
			name={state.valueId}
			placeholder={state.config.placeholder}
			value={state.value || ""}
			onChange={handleChange}
		/>;

		return <>
			{inputEl}
			<span className={stl.el("input-print").mod(mods).str}>{printValue}</span>
			{state.config.suffix ?
				<span className={stl.el("input-suffix").str}>{state.config.suffix}</span>
			: null }
		</>

	}} />

}